<template>
  <el-container style="height: 100%;">
      <el-header style="height: 80px;padding: 0px;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form :inline="true" class="demo-form-inline" size="mini" style="margin-top: 5px;margin-left: 10px">
          <el-form-item label="门店">
            <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
              <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="openAddCardManager">新增</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main style="padding: 0px;height: calc(100% - 2rem)">
        <el-table v-loading="queryLoadBtton" height="100%"  size="mini" :data="cardManagers" highlight-current-row @cell-click="cardManagerCell"  :cell-class-name="tableCellClassName">
          <el-table-column label="会员信息" prop="cardnumber"  align="center" width="120" fixed>
            <template slot-scope="scope">
              <div>{{scope.row.membername}}</div>
              <div>{{scope.row.cardnumber}}</div>
            </template>
          </el-table-column>
          <el-table-column label="铺垫信息" prop="bedding"  align="center">
            <template slot-scope="scope">
                <div style="background-color: #409EFF;width: 70px;float: left;color: white;margin-right: 1px" v-for="(item,idx) in scope.row.cardBeddings">
                    <div>{{item.accountdate}}</div>
                    <div>{{item.beddingname}}</div>
                    <div style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden">{{item.bedding}}</div>
                </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    <el-dialog title="新增大健康会员" :visible.sync="dialogVisible" width="100%">
      <el-form class="demo-form-inline" :model="addCardManager" ref="form" :rules="rules" size="mini" style="margin-top: 5px;margin-left: 10px">
        <el-form-item label="会员卡号" prop="cardid">
          <el-select v-model="addCardManager.cardid" clearable filterable remote :remote-method="remoteMethod"
                     placeholder="请输入会员卡号，姓名，手机号码" style="width: 100%" @change="cardChange" @focus="closeReadOnly" @blur="closeReadOnly">
            <el-option v-for="(item,key) in cardInfos" :value="item.cardid" :label="item.cardnumber+'-'+item.membername" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员姓名" prop="membername">
          <el-input v-model="addCardManager.membername" disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveCardManager" :loading="queryLoadBtton">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增会员铺垫" :visible.sync="dialogBeddingVisible" width="100%" >
      <el-form class="demo-form-inline" :model="addCardBedding" ref="form" :rules="rules" size="mini" label-width="80px">
        <el-form-item label="会员卡号" prop="cardnumber">
          <el-input v-model="addCardBedding.cardnumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="会员姓名" prop="membername">
          <el-input v-model="addCardBedding.membername" disabled></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="accountdate">
          <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%"
                          v-model="addCardBedding.accountdate" name="birthday"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="铺垫人" prop="beddingtor">
          <el-select v-model="addCardBedding.beddingtor" placeholder="请选择" style="width: 100%" size="mini" @change="beddingtorChange" clearable>
            <el-option v-for="item in staffs" :key="item.staffid" :label="item.staffname" :value="item.staffid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成交率" prop="lv">
          <el-select v-model="addCardBedding.lv" style="width: 100%" placeholder="请选择" size="mini" clearable>
            <el-option  label="10%" :value="0.1"></el-option>
            <el-option  label="20%" :value="0.2"></el-option>
            <el-option  label="30%" :value="0.3"></el-option>
            <el-option  label="40%" :value="0.4"></el-option>
            <el-option  label="50%" :value="0.5"></el-option>
            <el-option  label="60%" :value="0.6"></el-option>
            <el-option  label="70%" :value="0.7"></el-option>
            <el-option  label="80%" :value="0.8"></el-option>
            <el-option  label="90%" :value="0.9"></el-option>
            <el-option  label="100%" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="铺垫内容" prop="bedding">
          <el-input type="textarea"  :autosize="{ minRows: 2, maxRows: 4}" v-model="addCardBedding.bedding" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogBeddingVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveCardBedding" :loading="queryLoadBtton">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      staffs:[],
      addCardBedding:{},
      cardbedding:{
        storeid:"",
        cardid:"",
        cardnumber:"",
        membername:"",
        accountdate:this.$moment().format('YYYY-MM-DD'),
        billtype:1,
        beddingtor:"",
        beddingname:"",
        lv:0,
        bedding:"",
        createtor:"",
        createname:"",
        createdate:"",
      },
      dialogBeddingVisible:false,
      rules: {
        cardid: [
          {required: true, message: "请输入会员卡号，姓名，手机号码", trigger: 'blur'}
        ],
      },
      bedrules: {
        beddingtor: [
          {required: true, message: "请选择铺垫人", trigger: 'blur'}
        ],
        lv: [
          {required: true, message: "请选择成交率", trigger: 'blur'}
        ],
        bedding:[
          {required: true, message: "请输入铺垫内容", trigger: 'blur'}
        ]
      },
      dialogVisible:false,
      brands: [],
      storeid:localStorage.getItem("storeid"),
      cardManagers:[],
      queryLoadBtton:false,
      cardManager:{
        storeid:"",
        cardid:"",
        billtype:1,
        cardnumber:"",
        memberid:"",
        membername:"",
        memberphone:"",
        createtor:"",
        createname:"",
        createdate:"",
      },
      addCardManager:{},
      cardInfos:[],
      curIndex:0,
    }
  },
  created() {
    let tempstoreid=this.$route.query.storeid;
    if(tempstoreid){
      this.storeid=tempstoreid;
    }
    this.getStoreInfoByStructsOpen();
    this.getCardManagerByStore();
    this.getBeautyStaff();
  },
  updated () {
    this.closeReadOnly();
  },
  methods: {
    closeReadOnly(){
      // 去除el-select默认的readOnly，否则移动端下拉框出不来
      Array.from(document.getElementsByClassName('el-select')).forEach(item => {
        item.children[0].children[0].removeAttribute('readOnly');
        item.children[0].children[0].onblur = function () {
          let _this = this;
          _this.removeAttribute('readOnly');
        }
      });
    },
    beddingtorChange(val){
      for(let s of this.staffs){
        if(s.staffid==val){
          this.addCardBedding.beddingname=s.staffname;
          break;
        }
      }
    },
    tableCellClassName({row, column, rowIndex, columnIndex}){
      this.curIndex=rowIndex;
    },
    getBeautyStaff(){
      this.$post("cardmanager/getBeautyStaff",{storeid:this.storeid}).then(res=>{
        if(res.sucess){
          this.staffs=res.object;
        }
        else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      });
    },
    saveCardBedding(){
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if(this.addCardBedding.lv<0.1) {
            this.$message({
              message: "请选择成交率",
              type: 'error'
            });
            return;
          }
          this.queryLoadBtton=true;
          this.addCardBedding.storeid=this.storeid;
          this.addCardBedding.createtor=localStorage.getItem("staffid");
          this.addCardBedding.createname=localStorage.getItem("staffname");
          this.$postw("cardmanager/addCardBedding",this.addCardBedding).then(res=>{
            this.queryLoadBtton=false;
            if(res.sucess){
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              if(this.cardManagers[this.curIndex].cardBeddings==null){
                this.cardManagers[this.curIndex].cardBeddings=[];
              }
              this.cardManagers[this.curIndex].cardBeddings.push(this.addCardBedding);
              this.dialogBeddingVisible=false;
              //this.getCardManagerByStore();
            }
            else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          });
        }
      });
    },
    openCardBedding(){
      this.dialogBeddingVisible=true;
      this.addCardBedding=this.$copy(this.cardbedding);
    },
    openCardBeddingInfo(row){
      this.$router.push({path:"/cardbeddinginfo",query:{
          storeid:row.storeid,
          cardid:row.cardid
          }});
    },
    cardManagerCell(row, column, event, cell){
      //console.log(row,column,event,cell);

      if(column.property=="bedding"){
        this.openCardBedding();
        this.addCardBedding.storeid=row.storeid;
        this.addCardBedding.cardid=row.cardid;
        this.addCardBedding.cardnumber=row.cardnumber;
        this.addCardBedding.membername=row.membername;
      }
      else if(column.property=="cardnumber"){
        this.openCardBeddingInfo(row);
      }
    },
    saveCardManager(){
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.queryLoadBtton=true;
          this.addCardManager.storeid=this.storeid;
          this.addCardManager.createtor=localStorage.getItem("staffid");
          this.addCardManager.createname=localStorage.getItem("staffname");
          this.$postw("cardmanager/addCardManager",this.addCardManager).then(res=>{
            this.queryLoadBtton=false;
            if(res.sucess){
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.dialogVisible=false;
              this.getCardManagerByStore();
            }
            else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          });
        }
      });
    },
    cardChange(val){
      for(let c of this.cardInfos){
        if(val==c.cardid){
          this.addCardManager.cardnumber=c.cardnumber;
          this.addCardManager.memberid=c.memberid;
          this.addCardManager.membername=c.membername;
          this.addCardManager.memberphone=c.memberphone;
        }
      }
    },
    remoteMethod(query){
      if (query !== '') {
        this.$post("cardinfo/getCardInfoByCash",{storeid:this.storeid,param:query}).then(res=>{
          if(res.sucess){
            this.cardInfos=res.object;
            this.$nextTick(function (){
              if(this.cardInfos.length==1){
                let cardinfo=this.cardInfos[0];
                this.addCardManager.cardid=cardinfo.cardid;
                this.addCardManager.cardnumber=cardinfo.cardnumber;
                this.addCardManager.memberid=cardinfo.memberid;
                this.addCardManager.membername=cardinfo.membername;
                this.addCardManager.memberphone=cardinfo.memberphone;
              }
            })
          }
          else{
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      }
    },
    openAddCardManager(){
      this.addCardManager=this.$copy(this.cardManager);
      this.dialogVisible=true;
    },
    storeChange(val){
      //localStorage.setItem("storeid",val);
      this.storeid=val;
      this.getCardManagerByStore();
      this.getBeautyStaff();
    },
    getCardManagerByStore(){
      this.$post("cardmanager/getCardManagerByStore",{storeid:this.storeid}).then(res=>{
        if(res.sucess){
          this.cardManagers=res.object;
        }
        else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      });
    },
    getStoreInfoByStructsOpen() {
      let parentstoreid = localStorage.getItem("parentstoreid");
      let staffid = localStorage.getItem("staffid");
      this.$post("store/getStoreByStructsByStaffId", {storeid: parentstoreid, staffid: staffid}).then(res => {
        if (res.sucess) {
          this.brands = res.object;
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/page/beauty/bighealthy.vue